import React,{useEffect,useState} from 'react'
import ContactImg from '../img/contact_us.jpg';
import emailjs from "emailjs-com";
import axios from "axios";

export default function ContactUs() {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array means this runs once when the component mounts

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

   // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
    await axios.post(
      "https://ssveng.com/contact_api/insert.php",
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    alert("Message sent successfully!");

    setFormData({
      name: "",
      email: "",
      message: "",
    });
  } catch (error) {
    console.error(error);
    alert("Error submitting form");
  }
  };


  return (
    <>
      <section id="industry" className="services" style={{padding: "0 0 !important"}}>
        {/* <div className="w3-display-container w3-animate-opacity">
          <img src={ContactImg} alt="boat" style={{width:"100%",minHeight:"350px",maxHeight:"600px"}} />
        </div> */}
        <div className="container" style={{opacity: "1",paddingBottom: "20px"}}>
          <div className="section-header">
            <div className="container" style={{paddingLeft: "70px",paddingRight: "70px"}}>
                <h2>Contact Us</h2>
                <p>Looking for precision laser cutting, metal bending, and custom metal fabrication services? Our expert team delivers high-quality, accurate, and reliable manufacturing solutions for industrial and commercial projects. Contact us today to discuss your requirements, get a quick quote, and experience efficient turnaround with superior workmanship.</p>
            </div>
          </div>
          <div className="container" id="contact_container">
            <div className="row">
              <section className="contact-page-sec" style={{paddingTop: "10px"}}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="contact-info">
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <i className="fas fa-map-marked"></i>
                          </div>
                          <div className="contact-info-text">
                            <h2>address</h2>
                            <span>D/8, Sayan Textile Park, Ichchhapor,</span> 
                            <span>Chorasi, Surat</span> 
                          </div>
                        </div>            
                      </div>          
                    </div>          
                    <div className="col-md-4">
                      <div className="contact-info">
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <i className="fas fa-envelope"></i>
                          </div>
                          <div className="contact-info-text">
                            <h2>E-mail</h2>
                            <span>info.ssveng@gmail.com</span><br/>
                            <span>&nbsp;</span>
                          </div>
                        </div>            
                      </div>                
                    </div>                
                    <div className="col-md-4">
                      <div className="contact-info">
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <i className="fas fa-phone"></i>
                          </div>
                          <div className="contact-info-text">
                            <h2>Phone</h2>
                            <span>+91 99799 78869</span><br/>
                            <span>&nbsp;</span>
                          </div>
                        </div>            
                      </div>          
                    </div>          
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="contact-page-form" method="post">
                        <h2>Send Your Message</h2> 
                        <form action="" id="contact-form" onSubmit={handleSubmit}>
                          <div className="row">
                          <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="single-input-field">
                              <input type="text" placeholder="Your Name" name="name" value={formData.name} onChange={handleChange} />
                            </div>
                          </div>  
                          <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="single-input-field">
                              <input type="email" placeholder="E-mail" name="email" required value={formData.email} onChange={handleChange} />
                            </div>
                          </div>                
                          <div className="col-md-12 message-input">
                            <div className="single-input-field">
                              <textarea  placeholder="Write Your Message" name="message" value={formData.message} onChange={handleChange}></textarea>
                            </div>
                          </div>                                                
                          <div className="single-input-fieldsbtn">
                            <button type="submit"> Send Message </button>
                          </div>        
                        </div>
                        </form>   
                      </div>      
                    </div>
                    <div className="col-md-4">        
                      <div className="contact-page-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d725.3462323388159!2d72.74370856583117!3d21.193244857742936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04da35880aca3%3A0xb8acc6f90463dc7d!2sShree%20Siddhi%20Vinayak%20Engineering!5e1!3m2!1sen!2sin!4v1767778991758!5m2!1sen!2sin" width="600" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                      </div>          
                    </div>        
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}